<template>
	<c-dialog ref="dialog" title="上传付款凭证及开票信息" width="750" height="600" button-name="确认并提交" @resolve="submitHandle">
		<div class="company-info flex-between-center">
			<div>
				<p>保险公司账号：{{insuranceInfo.bank_code}}</p>
				<p>保险公司户名：{{insuranceInfo.account_name}}</p>
				<p>保险公司开户行：{{insuranceInfo.bank_name}}</p>
			</div>
			<div class="flex-column flex-center">
				<strong>{{detailInfo.bf_money}}元</strong>
				<b>保费金额</b>
			</div>
		</div>
		
		<div class="upload">
			<c-upload-file v-model="voucher" type="image" media="image" button="上传付款凭证"></c-upload-file>
		</div>
		
		<div class="title">开票信息</div>
		<c-form ref="form" unit-width="400" style="padding-top: 0;">
			<c-form-item v-model="currentInvoiceType" type="radio" label="发票类型" name="fp_type" required :options="invoiceType"></c-form-item>
			<div v-show="currentInvoiceType != 3">
				<c-form-item type="input" label="发票抬头" name="fp_title" required></c-form-item>
				<c-form-item type="input" label="纳税识别号" name="fp_nsrsbh" required></c-form-item>
				<c-form-item type="input" label="开户银行" name="fp_bank" required></c-form-item>
				<c-form-item type="input" label="银行账号" name="fp_account" required></c-form-item>
				<c-form-item type="input" label="收票联系人" name="fp_lxr"></c-form-item>
				<c-form-item type="input" label="收票地址" name="fp_address"></c-form-item>
				<c-form-item type="input" label="联系电话" name="fp_lxdh"></c-form-item>
				<c-form-item type="input" label="电子邮箱" name="fp_email" required></c-form-item>
			</div>
		</c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		data() {
			return {
				detailInfo: {},
				insuranceInfo: {},
				voucher: '',
				currentInvoiceType: ''
			}
		},
		
		computed: {
			...mapState(['invoiceType'])
		},
		
		methods: {
			open(id) {
				this._id = id;
				this.$refs.form.clear();
				this.request({
					url: '/project/bx/detail',
					data: {
						bx_id: id
					},
					loading: true,
					success: data => {
						this.detailInfo = data.bxInfo;
						this.insuranceInfo = data.bxgsInfo;
						this.$refs.dialog.open();
					}
				});
				this.request({
					url: '/project/bx/lastBxFp',
					success: data => {
						this.$refs.form.set(data);
					}
				});
			},
			
			submitHandle(stop, next) {
				stop();
				if (!this.voucher) {
					this.$message({
						text: '请上传付款凭证'
					});
					return;
				}
				
				this.$refs.form.submit({
					url: '/project/bx/updateBxfp',
					rule: this.currentInvoiceType == 3 ? {} : {
						fp_type: '请选择发票类型',
						fp_title: '请填写发票抬头',
						fp_nsrsbh: '请填写纳税识别号',
						fp_bank: '请填写开户行',
						fp_account: '请填写账号',
						fp_email: '请填写电子邮箱'
					},
					dataFormatter: data => {
						data.bx_id = this._id;
						data.fp_fk_path = this.voucher;
						return data;
					},
					success: () => {
						next();
						this.$message({
							text: '提交成功'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.company-info {
		padding: 10px 24px 10px 18px;
		margin: 16px 20px;
		background: #F1F8FE;
		
		p {
			line-height: 28px;
			font-size: 13px;
			color: #444;
		}
		
		strong {
			font-size: 24px;
			color: #f00;
		}
		
		b {
			margin-top: 10px;
			font-size: 14px;
			color: #000;
		}
	}
	
	.upload {
		margin: 15px 24px 30px;
	}
	
	.title {
		padding-left: 24px;
		line-height: 60px;
		font-size: 18px;
		font-weight: bold;
	}
</style>
